// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__UAJFw","addWidgetButton":"Header_addWidgetButton__Yuagt","dashboardTabs":"Header_dashboardTabs__2jiwt","active":"Header_active__3joeO"};